export default [
  //"modules/accordions",
  "modules/archive-meals-restaurant-details",
  "modules/archive-restaurants",
  //"modules/filtered-posts-list",
  //"modules/google-map",
  //"modules/lottie",
  "modules/meal-archives",
  //"modules/newsletter",
  "modules/pb-row-featured-meals",
  "modules/pb-row-horizontal-scroller",
  "modules/pb-row-jobs",
  "modules/pb-row-medias",
  //"modules/pb-row-oembed",
  "modules/pb-row-promo-slider",
  "modules/pb-row-salad-bar",
  "modules/pb-row-stats",
  //"modules/pb-row-tabs",
  "modules/pb-row-testimonials",
  //"modules/pb-row-wrapper-reveal",
  //"modules/prefers-color-scheme-btn",
  "modules/schedules",
  //"modules/scrolling-images-sequence",
  //"modules/sharing",
  //"modules/svg-path-length",
  //"modules/text-ticker",
  "modules/title-replacements",
  "modules/video"
];
